// Mirrors impire-sdk-go/config/wire.go — the configuration service's wire as
// the library carries it (02-DESIGN/06-configuration/01-the-configuration-service.md;
// decision 0012): the five operations, the one kind served, the document
// every platform image reads, the envelope inside every reply, the
// expect-revision guard and its conflict, the error codes. Re-exported here so
// that a surface imports one wire module per Go file. A subject is built by
// the library, never inlined.

import { config } from "@impire-io/sdk";

/** SERVICE is the configuration service's micro service name. */
export const SERVICE = config.SERVICE;

/** The five operations. */
export const Op = config.Op;
export type Op = config.Op;

/** The kinds: `workload` is served, `solution` reserved. */
export const Kind = config.Kind;
export type Kind = config.Kind;

/** DOCUMENT_SETTINGS is the document every platform image and every workload on the bootstrap reads. */
export const DOCUMENT_SETTINGS = config.DOCUMENT_SETTINGS;

/** DOCUMENT_REQUIRED is the reserved document beside it: what is required of the workload (13-blueprints/03-required.md). */
export const DOCUMENT_REQUIRED = config.DOCUMENT_REQUIRED;

/** resolve is required over settings, as every platform image resolves the two. */
export const resolve = config.resolve;

/** MAX_DOCUMENT bounds a document, in bytes. */
export const MAX_DOCUMENT = config.MAX_DOCUMENT;

/** validDocument reports whether value is a document the service accepts: UTF-8 text of at most MAX_DOCUMENT bytes. */
export const validDocument = config.validDocument;

/** Entry is the envelope inside every reply: the member path, the revision, put or delete, the value on a put. */
export type Entry = config.Entry;

/** EntryOp is what an entry records. */
export const EntryOp = config.EntryOp;
export type EntryOp = config.EntryOp;

/** ListReply is a workload's documents with their revisions, never their contents. */
export type ListReply = config.ListReply;

/** The error codes: a conflict is a set whose expected revision is no longer current. */
export const Code = config.Code;

/** subjectOf builds the tenant form, `config.<op>.workload.<id>[.<document>]`. */
export function subjectOf(op: Op, workload: string, document = ""): string {
  return config.subject(op, Kind.workload, workload, document);
}

/** pathOf is the member path an entry's key carries, `workload.<id>.<document>`. */
export function pathOf(workload: string, document = ""): string {
  return config.path(Kind.workload, workload, document);
}

/** documentOf reads the document's name back from an entry's key, `workload.<id>.<document>`: the last token. */
export function documentOf(key: string): string {
  const i = key.lastIndexOf(".");
  return i < 0 ? key : key.slice(i + 1);
}

/** validDocumentName reports whether s is one subject token, which is what a document's name must be. */
export function validDocumentName(s: string): boolean {
  return s !== "" && /^[\x21-\x7e]+$/.test(s) && !/[.*>]/.test(s);
}
